import * as React from "react";
var List = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("ul", { className: className }, children));
};
export { List };
